import type { FaireProductEntity } from "../../entity_types/product";

export const p_knzvrvtdkc: FaireProductEntity = {
  token: "p_knzvrvtdkc",
  type: "product",
  name: "Baby Girl Outfit | Oatmeal Knot Gown Pink Baby Sister",
  brandToken: "b_8wc7yrktuq",
  brandName: "Wonderfully Made",
  imageUrl:
    "https://cdn.faire.com/fastly/8d3cd883facea7ef01810168aa843018be6cca8faf0dd8aba1cb09b23008cb2d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1c1749be7aed2ada3834e06bd3087010828c866790486365d0eddf4e007b5e05.jpeg",
    "https://cdn.faire.com/fastly/e654f85590c7531cef584ba28336749c5a33bef7d7575d819f2871c00dbcd85d.jpeg",
    "https://cdn.faire.com/fastly/d2dfab71687b3af41dca67f6f359e5415339ce95ab89161e1e6b1b6a06a57ec0.jpeg",
  ],
  priceDollars: 19.95,
  description:
    "This outfit makes a perfect baby announcement outfit, coming home outfit, newborn pictures, or baby shower gift. This sweet sleeper is soft and comfortable to snuggle a little one. This features a soft knotted and you can also choose to add a hat to finish off this cute baby outfit. It has fold over mittens to protect baby and easy access for changing with a knot.\n\nPreemie 5-7lbs (mis-tagged as newborn)\n Newborn fits approximately 6-9lbs\n 0/3 fits approximately 9-13lbs\n\n\nAll embroidered items have a soft mesh backing to cover stitching on the underside of the garment, to protect thread from rubbing or causing discomfort. \n",
  tags: [],
  msrpDollars: 39.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:09.625Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
